module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av194-1bdea1cd1c5ea734c44b3c3e8fe72a9a.jpg";